import React, { useRef, useState, useEffect } from "react";
import MiniSideBar from "../../components/mini-sidebar";
import {
    Box,
    Flex,
    Image,
    Menu,
    MenuButton,
    Text,
    MenuList,
    MenuItem,
    Td,
    Tr,
    Divider,
    Card,
    CardBody
} from "@chakra-ui/react";
import SecondaryNav from "../../components/seconday-nav";
import PrimaryButton from "../../components/primary-button";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import SimpleTable from "../../components/simple-table";
import ModalRight from "../../components/modal-right";
import moment from "moment";
import { getLoginID, useScreenType, getCurrency, formatToDecimal, actionAccessMain } from "../../auth";
import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import { PrimaryInput, Toaster } from "../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { AddHsnCode, DeleteHsnCode, GetHsnCode, UpdateHsnCode } from "../../middleware/services/hsnmanagement";
import DynamicModal from "../../components/dynamic-modal";


const HSNManagement = () => {
    const [actionAccess, setActionAccess] = useState(null);
    var [doctorid, setDoctorid] = useState(getLoginID());
    var [hsncode, setHsnCode] = useState("");
    var [hsnCodeId, setHsnCodeId] = useState("");
    var [description, setDescription] = useState("");
    var [cgst, setCgst] = useState("");
    var [sgst, setSgst] = useState("");
    const { isLoading, showLoader, dismissLoader } = useLoader();
    const screenType = useScreenType();
    const [currency, setCurrency] = useState("");
    const [lablist, setLabList] = useState(null);
    const { showSuccessToast, showErrorToast } = Toaster();
    const [searchtext, setSerachText] = useState("");
    const addhsncode = useRef();
    const edithsncode = useRef();
    const deletelabprice = useRef();
    let itemPerPageCommonValue = 50;
    let [pageno, setPageno] = useState(1);
    let [pagesize, setPagesize] = useState(itemPerPageCommonValue);
    let [countTo, setCountTo] = useState(itemPerPageCommonValue);
    let [countFrom, setCountFrom] = useState(1);
    let [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);
    const [totalItemCount, setTotalItemCount] = useState(0);
    let [currentPage, setCurrentPage] = useState(1);
    let [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setActionAccess(actionAccessMain(12));
        fetchLabList(pageno);
        const currency = getCurrency();
        if (currency === "USD") {
            const uscurrency = '$';
            setCurrency(uscurrency);
        } else {
            setCurrency(currency);
        }
    }, [pageno]);

    const fetchLabList = async (page) => {
        showLoader();
        try {
            const result = await GetHsnCode({ "doctorid": doctorid, "pageno": page, "pagesize": pagesize });
            if (result != null) {
                setLabList(result.output.data);
                setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
                setTotalItemCount(result.output.count);
                if (result.output.count < itemPerPageCommonValue) {
                    setCountTo(result.output.count);
                    setTotalExceedsPageCount(true);
                } else {
                    setTotalExceedsPageCount(false);
                }
            }
            dismissLoader();
        } catch (error) {
            console.error("Error in fetching lab list:", error);
        }
    };

    const handleNextClick = () => {
        if (countTo + pagesize < totalItemCount) {
            setCountTo(countTo + pagesize);
        } else {
            setCountTo(totalItemCount);
        }
        setCountFrom(countFrom + pagesize);
        setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
        fetchLabList(currentPage + 1);
    };

    const handlePreviousClick = () => {
        if (countTo == totalItemCount) {
            setCountTo(totalItemCount - pagesize);
        } else {
            setCountTo(countTo - pagesize);
        }
        setCountFrom(countFrom - pagesize);
        setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
        fetchLabList(currentPage - 1);
    };

    const openAddModal = () => {
        setHsnCode("");
        setCgst("");
        setSgst("");
        setDescription("");
        addhsncode.current.openRight();
    };

    const openEditModal = (item) => {
        setHsnCode(item.hsncode);
        setHsnCodeId(item.id)
        setDescription(item.description);
        setCgst(item.cgst);
        setSgst(item.sgst);
        edithsncode.current.openRight();
    };

    const openDeleteModal = (item) => {
        setHsnCode(item.hsncode);
        setHsnCodeId(item.id)
        deletelabprice.current.openModal();
    };

    const addLabTest = async () => {
        const hsncodeData = {
            hsncode,
            description,
            cgst: parseFloat(cgst),
            sgst: parseFloat(sgst),
            doctorid,
        };
        const response = await AddHsnCode(hsncodeData);
        if (response) {
            showSuccessToast("Lab Test Added Successfully");
            addhsncode.current.closeRight();
            fetchLabList(pageno);
        }
    };

    const editLabTest = async () => {
        const hsncodeData = {
            id: hsnCodeId,
            hsncode,
            description,
            cgst: parseFloat(cgst),
            sgst: parseFloat(sgst),
            doctorid,
        };
        const response = await UpdateHsnCode(hsncodeData);
        if (response) {
            showSuccessToast("Lab Test Updated Successfully");
            edithsncode.current.closeRight();
            fetchLabList(pageno);
        }
    };

    const deleteLabTest = async () => {
        const response = await DeleteHsnCode({ id: hsnCodeId, doctorid });
        if (response) {
            showSuccessToast("Lab Test Deleted Successfully");
            deletelabprice.current.closeModal();
            fetchLabList(pageno);
        }
    };

    const gobackfunction = () => {
        window.history.back();
    }

    // Functions for search, filter, and reset
    const FilterResult = async (e) => {
        if (e.key === "Enter") {
            showLoader();
            try {
                setPageno(1);
                setPagesize(itemPerPageCommonValue);
                setCountFrom(1);
                setCountTo(itemPerPageCommonValue);
                setCurrentPage(1);

                const result = await GetHsnCode({
                    hsncode: searchtext,
                    "pageno": "1",
                    pagesize,
                });

                if (result != null) {
                    setLabList(result.output.data);
                    setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
                    setTotalItemCount(result.output.count);
                    if (result.output.count < itemPerPageCommonValue) {
                        setCountTo(result.output.count);
                        setTotalExceedsPageCount(true);
                    } else {
                        setTotalExceedsPageCount(false);
                    }
                }
                dismissLoader();
            } catch (error) {
                console.error("Error in search:", error);
            }
        }
    };

    const Filteranything = async (e) => {
        showLoader();
        try {
            setPageno(1);
            setPagesize(itemPerPageCommonValue);
            setCountFrom(1);
            setCountTo(itemPerPageCommonValue);
            setCurrentPage(1);

            const result = await GetHsnCode({
                hsncode: searchtext,
                "pageno": "1",
                pagesize,
            });

            if (result != null) {
                setLabList(result.output.data);
                setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
                setTotalItemCount(result.output.count);
                if (result.output.count < itemPerPageCommonValue) {
                    setCountTo(result.output.count);
                    setTotalExceedsPageCount(true);
                } else {
                    setTotalExceedsPageCount(false);
                }
            }
            dismissLoader();
        } catch (error) {
            console.error("Error in filtering:", error);
        }
    };

    const resetFields = () => {
        setCurrentPage(1);
        setPageno(1);
        setPagesize(itemPerPageCommonValue);
        setCountFrom(1);
        setCountTo(itemPerPageCommonValue);
        setCurrentPage(1);
        setSerachText("")
        fetchLabList(1);
    };

    const TableHeader = [
        { key: "hsncode", label: "HSN Code" },
        { key: "sgst", label: "SGST" },
        { key: "cgst", label: "CGST" },
        { key: "actions", label: "Actions" },
    ];
    return (
        <>
            {screenType === 'web' ? (
                <Box w="100%">
                    <Flex>
                        <Box w="6rem">
                            <MiniSideBar />
                        </Box>
                        {isLoading && <Loader />}
                        <Box w="100%">
                            <SecondaryNav withBack="HSN Management" goBack={gobackfunction} />
                            <Box
                                gap="10px"
                                my="1rem"
                                px="1rem"
                                w="100%"
                                display="flex"
                                flexDirection="row"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Box w="100%" display="flex" justifyContent="space-between">
                                    <Flex w='100%' gap='1rem'>
                                        <PrimaryInput
                                            variant="fullRound"
                                            inputPlace="Search"
                                            onKeyPress={FilterResult}
                                            maxLength={50}
                                            onChange={(e) => setSerachText(e.target.value)}
                                            inputValue={searchtext}
                                        />
                                        <PrimaryButton
                                            buttonText="Filter"
                                            id="filterButton"
                                            variant="mdBtn"
                                            btnStyle={{ w: "80px" }}
                                            onClick={Filteranything}
                                        />
                                        <PrimaryButton
                                            buttonText="Reset"
                                            id="resetButton"
                                            variant="grayBtn"
                                            btnStyle={{ color: "#AA2F27" }}
                                            onClick={resetFields}
                                        />
                                        <PrimaryButton
                                            buttonText="Add"
                                            id="filterButton"
                                            variant="mdBtn"
                                            btnStyle={{ w: "80px" }}
                                            onClick={openAddModal}
                                            isDisabled={actionAccess && !actionAccess.create}
                                        />
                                    </Flex>
                                </Box>
                            </Box>
                            <Divider />
                            <Box>
                                <SimpleTable
                                    headers={TableHeader}
                                    isDataPresent={true}
                                    ThStyle={{
                                        bg: "#FAFAFA",
                                    }}
                                    footerStyle={{
                                        pos: "fixed",
                                        bottom: "0px",
                                        boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                                        zIndex: '999',
                                        w: "100%"
                                    }}
                                    tableStyle={{
                                        minH: "calc(100vh - 150px)",
                                        maxH: "calc(100vh - 150px)",
                                        overflowY: "auto",
                                        tableLayout: "fixed",
                                        width: "100%",
                                        border: "1px solid #E6E7E9",
                                    }}
                                    tableBody={
                                        <>
                                            {lablist &&
                                                lablist.map((step, index) => (
                                                    <Tr w="100%" key={index}>
                                                        <Td w="100x">
                                                            <Text fontSize=".875rem" fontWeight="500">
                                                                {step.hsncode ? step.hsncode : ""}
                                                            </Text>
                                                        </Td>
                                                        <Td>
                                                            <Text fontSize=".875rem" fontWeight="500">
                                                                {step.sgst || step.sgst == 0 ? step.sgst + "%" : "-"}
                                                            </Text>
                                                        </Td>
                                                        <Td>
                                                            <Text fontSize=".875rem" fontWeight="500">
                                                                {step.cgst || step.cgst == 0 ? step.cgst + "%" : '-'}
                                                            </Text>
                                                        </Td>
                                                        <Td pos="relative">
                                                            <Menu isLazy>
                                                                <MenuButton as="button" zIndex={1}>
                                                                    <Image
                                                                        w="1.5rem"
                                                                        src="/assets/svgs/more-options.svg"
                                                                    />
                                                                </MenuButton>
                                                                <MenuList
                                                                    zIndex={2}
                                                                    pos="relative"
                                                                    right="100px"
                                                                    minW="125px"
                                                                >
                                                                    <MenuItem onClick={() => openEditModal(step)}
                                                                        isDisabled={actionAccess && (!actionAccess.update) ? true : false}>
                                                                        Edit
                                                                    </MenuItem>
                                                                    <MenuItem onClick={() => openDeleteModal(step)}
                                                                        isDisabled={actionAccess && (!actionAccess.delete) ? true : false}>
                                                                        Delete
                                                                    </MenuItem>
                                                                </MenuList>
                                                            </Menu>
                                                        </Td>
                                                    </Tr>
                                                ))}
                                        </>
                                    }
                                />
                            </Box>
                        </Box>
                    </Flex>
                </Box>
            ) : (
                <>
                    <MobileNavbar />
                    <MobileSecondaryNav
                        header="Lab Setup"
                        handlebackarrow={false}
                    />
                </>
            )}

            {/* Add Modal */}
            <ModalRight
                ref={addhsncode}
                header="Add HSN"
                modalWidth={{ base: "100%", lg: "calc(100vw - 60%)" }}
                body={
                    <>
                        <Box w="100%" mt="1rem">
                            <Box w="100%" display="flex">
                                <PrimaryInput
                                    variant="leftSide"
                                    inputPlace="HSN Code*"
                                    onChange={(e) => setHsnCode(e.target.value)}
                                    inputValue={hsncode}
                                    maxLength={60}
                                />
                                <PrimaryInput
                                    variant="rightSide"
                                    inputPlace="Description"
                                    onChange={(e) => setDescription(e.target.value)}
                                    inputValue={description}
                                    maxLength={200}
                                />
                            </Box>
                            <Box w="100%" display="flex">
                                <PrimaryInput
                                    variant="leftDown"
                                    inputPlace="SGST* %"
                                    onChange={(e) => setSgst(e.target.value)}
                                    inputValue={sgst}
                                    maxLength={3}
                                />
                                <PrimaryInput
                                    variant="rightDown"
                                    inputPlace="CGST* %"
                                    onChange={(e) => setCgst(e.target.value)}
                                    inputValue={cgst}
                                    maxLength={6}
                                />
                            </Box>
                        </Box>
                    </>
                }
                footerActions={
                    <>
                        <Box w="100%" display="flex" gap="1rem">
                            <PrimaryButton
                                buttonText="Cancel"
                                variant="grayBtnFull"
                                btnStyle={{ color: "#AA2F27" }}
                                onClick={() => addhsncode.current.closeRight()}
                            />
                            <PrimaryButton
                                buttonText="Save"
                                onClick={addLabTest}
                            />
                        </Box>
                    </>
                }
            />

            {/* Edit Modal */}
            <ModalRight
                ref={edithsncode}
                header="Edit HSN"
                modalWidth={{ base: "100%", lg: "calc(100vw - 60%)" }}
                body={
                    <>
                        <Box w="100%" mt="1rem">
                            <Box w="100%" display="flex">
                                <PrimaryInput
                                    variant="leftSide"
                                    inputPlace="HSN Code*"
                                    onChange={(e) => setHsnCode(e.target.value)}
                                    inputValue={hsncode}
                                    maxLength={60}
                                />
                                <PrimaryInput
                                    variant="rightSide"
                                    inputPlace="Description"
                                    onChange={(e) => setDescription(e.target.value)}
                                    inputValue={description}
                                    maxLength={200}
                                />
                            </Box>

                            <Box w="100%" display="flex">
                                <PrimaryInput
                                    variant="leftDown"
                                    inputPlace="SGST* %"
                                    onChange={(e) => setSgst(e.target.value)}
                                    inputValue={sgst}
                                    maxLength={3}
                                />
                                <PrimaryInput
                                    variant="rightDown"
                                    inputPlace="CGST* %"
                                    onChange={(e) => setCgst(e.target.value)}
                                    inputValue={cgst}
                                    maxLength={6}
                                />
                            </Box>
                        </Box>
                    </>
                }
                footerActions={
                    <>
                        <Box w="100%" display="flex" gap="1rem">
                            <PrimaryButton
                                buttonText="Cancel"
                                variant="grayBtnFull"
                                btnStyle={{ color: "#AA2F27" }}
                                onClick={() => edithsncode.current.closeRight()}
                            />
                            <PrimaryButton
                                buttonText="Save"
                                onClick={editLabTest}
                            />
                        </Box>
                    </>
                }
            />

            {/* Delete Modal */}
            <DynamicModal
                ref={deletelabprice}
                modalHeader="Delete Lab"
                modalBody={
                    <>
                        <Text fontSize="14px" fontWeight="600">
                            Are you sure you want to delete <b>{hsncode}</b>?
                        </Text>
                    </>
                }
                modalFooterBtn={
                    <>
                        <PrimaryButton
                            variant="deleteBtn"
                            buttonText="Delete"
                            onClick={deleteLabTest}
                        />
                    </>
                }
            />
        </>
    );
};

export default HSNManagement;
